import { Box, BoxProps } from "@chakra-ui/react";

export function VideoNewIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box position="relative" {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.0835 14.625H17.9168"
          stroke={color}
          stroke-width="1.25"
          stroke-linejoin="round"
        />
        <path
          d="M14.1665 18.7915L11.6665 14.6248"
          stroke={color}
          stroke-width="1.25"
          stroke-linejoin="round"
        />
        <path
          d="M8.3335 18.7915L5.8335 14.6248"
          stroke={color}
          stroke-width="1.25"
          stroke-linejoin="round"
        />
        <path
          d="M2.0835 10.8748C2.0835 14.6068 2.0835 16.4728 3.24287 17.6321C4.40223 18.7915 6.26821 18.7915 10.0002 18.7915C13.7321 18.7915 15.5981 18.7915 16.7575 17.6321C17.9168 16.4728 17.9168 14.6068 17.9168 10.8748C17.9168 7.14289 17.9168 5.27691 16.7575 4.11754C15.5981 2.95817 13.7321 2.95817 10.0002 2.95817C6.26821 2.95817 4.40223 2.95817 3.24287 4.11754C2.0835 5.27691 2.0835 7.14289 2.0835 10.8748Z"
          stroke={color}
          stroke-width="1.25"
        />
        <path
          d="M12.4609 8.46284C12.3347 7.94055 11.7381 7.57149 10.5449 6.83336C9.39145 6.1198 8.81471 5.76303 8.34994 5.90644C8.15779 5.96573 7.98271 6.07834 7.84152 6.23345C7.5 6.60865 7.5 7.33637 7.5 8.79183C7.5 10.2473 7.5 10.975 7.84152 11.3502C7.98271 11.5053 8.15779 11.6179 8.34994 11.6772C8.81471 11.8206 9.39145 11.4639 10.5449 10.7503C11.7381 10.0122 12.3347 9.64311 12.4609 9.12082C12.513 8.90523 12.513 8.67842 12.4609 8.46284Z"
          stroke={color}
          stroke-width="1.25"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
